export const HEADER_LABELS = {
  products: 'Products',
  solutions: 'Solutions',
  resources: 'Resources',
  company: 'Company',
  get_started: 'Get a free demo',
};

export const PRODUCTS = [
  {
    name: 'Spend Optimization',
    link: '/spend-insights?utm_ref=cleartech_navabar',
  },
  {
    name: 'Bill Payments',
    link: '/bill-payment-software?utm_ref=cleartech_navabar',
  },
  {
    name: 'Corporate Cards',
    link: '/corporate-cards?utm_ref=cleartech_navabar',
  },
];

export const RESOURCES_OPTIONS = [
  {
    name: 'Blog',
    link: '/blog?utm_ref=cleartech_navabar',
  },
  {
    name: 'Interview Series',
    link: '/interview-series?utm_ref=cleartech_navabar',
  },
  {
    name: 'Case Studies',
    link: '/case-studies?utm_ref=cleartech_navabar',
  },
  {
    name: 'Product Updates',
    link: '/whats-new/?utm_ref=cleartech_navabar',
  },
  {
    name: 'ROI Calculator',
    link: '/ap-automation-roi-calculator?utm_ref=cleartech_navabar',
  },
];

export const PRODUCT_OPTION = [
  {
    name: 'INDUSTRIES',
    child: [
      {
        id: 'saas',
        url: `/saas-industry-solutions?utm_ref=cleartech_navabar`,
        title: 'Saas',
      },
      {
        id: 'construction',
        url: '/construction-industry-solutions?utm_ref=cleartech_navabar',
        title: 'Construction',
      },
      {
        id: 'logistics',
        url: '/logistics-industry-solutions?utm_ref=cleartech_navabar',
        title: 'Logistics',
      },
      {
        id: 'restaurant',
        url: `/restaurants-industry-solutions?utm_ref=cleartech_navabar`,
        title: 'Restaurant',
      },
      {
        id: 'not_for_profit',
        url: `/nonprofit-industry-solutions?utm_ref=cleartech_navabar`,
        title: 'Not for profit',
      },
      {
        id: 'retail',
        url: `/retail-industry-solutions?utm_ref=cleartech_navabar`,
        title: 'Retail',
      },
      {
        id: 'real_estate',
        url: `/real-estate-industry-solutions?utm_ref=cleartech_navabar`,
        title: 'Real estate',
      },
      {
        id: 'healthcare',
        url: `/healthcare-industry-solutions?utm_ref=cleartech_navabar`,
        title: 'Healthcare',
      },
    ],
  },
  {
    name: 'BUSINESS ROLE',
    child: [
      {
        id: 'ceos_and_cfos',
        url: '/cfo-solutions?utm_ref=cleartech_navabar',
        title: 'CEOs and CFOs',
      },
      {
        id: 'controllers_and_accounting_heads',
        url: `/controller-solutions?utm_ref=cleartech_navabar`,
        title: 'Controllers And Accounting Heads',
      },
      {
        id: 'accounting_managers',
        url: `/accounting-manager-solutions?utm_ref=cleartech_navabar`,
        title: 'Accounting Managers',
      },
    ],
  },
];
